import type { SocialProvider } from '../api/userland'
import { readReferredBy } from './referredBy'

type TelegramWebApp = {
  openLink?: (url: string, options?: { try_instant_view?: boolean }) => void
}

type TelegramWindow = Window & {
  TelegramWebviewProxy?: unknown
  Telegram?: { WebApp?: TelegramWebApp }
}

export function isTelegramWebView(
  ua = typeof navigator === 'undefined' ? '' : navigator.userAgent,
  win: TelegramWindow | null = typeof window === 'undefined' ? null : (window as TelegramWindow)
): boolean {
  if (/Telegram/i.test(ua)) return true
  if (win?.TelegramWebviewProxy) return true
  if (win?.Telegram?.WebApp) return true
  return false
}

// The browser the user is sent to does not share the WebView's storage, so the
// resume URL carries what must survive the hop: the registration ticket and
// the referral code (by default the stored one).
export function socialResumeUrl(
  origin: string,
  provider: SocialProvider,
  ticket?: string,
  ref: string | null = readReferredBy()
): string {
  const url = new URL('/auth/continue', origin)
  url.searchParams.set('provider', provider)
  if (ticket) url.searchParams.set('ticket', ticket)
  if (ref) url.searchParams.set('ref', ref)
  return url.toString()
}

export function tryOpenExternalBrowser(
  url: string,
  win: TelegramWindow = window as TelegramWindow
): boolean {
  const openLink = win.Telegram?.WebApp?.openLink
  if (typeof openLink === 'function') {
    openLink(url, { try_instant_view: false })
    return true
  }
  return false
}
